import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Dejé de pensar todos los días qué cocinar. Eso ya vale todo.'
  }, {
    text: 'Ahora tengo comidas listas y no vivo improvisando.'
  }, {
    text: 'Es práctico, real y lo pude aplicar desde el primer día.'
  }, {
    text: 'Me bajó muchísimo el estrés mental.'
  }];
  return <section className="w-full bg-cream py-16 px-4 flex flex-col items-center" data-id="element-239">
      <div className="max-w-5xl w-full" data-id="element-240">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-12 text-center" data-id="element-241">
          Lo que dicen otras mujeres
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-242">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-sage relative" data-id="element-243">
              <Quote className="absolute top-4 right-4 text-sage opacity-50" size={40} data-id="element-244" />
              <div className="flex gap-1 mb-4" data-id="element-245">
                {[...Array(5)].map((_, i) => <Star key={i} className="text-gold-400 fill-current" size={20} data-id="element-246" />)}
              </div>
              <p className="text-brown-800 font-bold text-lg italic relative z-10" data-id="element-247">
                “{testimonial.text}”
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}